import React from 'react';
import { Slider as SliderHoiPoi } from '@Sage/hoi-poi-ui';

const Slider = ({ ...props }) => {
    return <SliderHoiPoi {...props} />;
};

export default Slider;
